import { history } from '@umijs/max';
import type { MouseEvent } from 'react';

export const isBrowserNavigationClick = (event: MouseEvent<HTMLElement>) =>
  event.defaultPrevented ||
  event.button !== 0 ||
  event.metaKey ||
  event.ctrlKey ||
  event.shiftKey ||
  event.altKey;

export const navigateWithBrowserGestureSupport = (
  event: MouseEvent<HTMLElement>,
  path?: string,
) => {
  if (!path || isBrowserNavigationClick(event)) {
    return;
  }

  event.preventDefault();
  history.push(path);
};
